/**
 * A function that maintains a single expanded row (exclusivity) among highest-level rows of the table.
 *
 * @deprecated use TableV2 and its subcomponents from '@frontend/components' instead.
 */
const collapseOthersExpand = (expanded, record, data, expandedRowKeys) => {
  const hasChildren = data?.some((record) => record.children != null) ?? true;

  // If we have children, we maintain exclusivity only among parents.
  // Using the default method below this causes an issue where opening a child closes its parent.
  if (hasChildren) {
    const allParents = data?.map((indexedRecord) => indexedRecord.key);

    const isParent =
      data?.some((indexedRecord) => indexedRecord.key === record.key) ?? true;
    if (expanded) {
      if (isParent) {
        // If we're a parent and we're expanding --> collapse all other parents and add us.
        return [
          ...expandedRowKeys.filter((el) => !allParents.includes(el)),
          record.key,
        ];
      } else {
        // If we're not a parent and we are expanding --> add us to the list.
        return [...expandedRowKeys, record.key];
      }
    } else {
      // Regardless of parental status --> remove us from the list.
      return expandedRowKeys.filter((el) => el != record.key);
    }
  }
  // If we don't have children, we can just maintain exclusivity by keeping a single record in the store and skip all the array indexing logic.
  else {
    return expanded === true ? [record.key] : [];
  }
};

export default collapseOthersExpand;
